import { ROLE_BOM } from "@/lib/utils";
import { RootState } from "@/redux/store";
import { useGetAttachmentById, useGetHelpDocumentByAudience } from "@/services";
import { useSelector } from "react-redux";

const useHelpDocument = () => {
  const currentRole = useSelector(
    (state: RootState) => state.currentData.currentRole
  );

  const { data: helpDocument, isLoading: isLoadingHelpDocument } =
    useGetHelpDocumentByAudience({audience: currentRole == ROLE_BOM ? "BOARD_MEMBER" : "OWNER"});
  
  const { data: attachment, isLoading: isAttachmentLoading } =
  useGetAttachmentById({
    id: helpDocument?.data?.attachment?.attachmentId,
    queryParams: {
      enabled: !!helpDocument?.data?.attachment?.attachmentId
    }
  });
    
  return {
    isLoadingHelpDocument,
    isAttachmentLoading,
    attachment
  }
}

export default useHelpDocument;